import React, { FC } from 'react';

import { Typography, Stack, useDesktop, BoxProps } from 'Modules/ui3';
import { fileUrl } from 'Modules/ui2';

import { ContentBox } from '../ContentBox';


type InfoBlockProps = BoxProps & {
    data: {
        title?: React.ReactNode;
        text?: React.ReactNode;
        image?: string;
    };
}

export const InfoBlock: FC<InfoBlockProps> = ({ data: { image, text, title }, ...props }) => {
    const isDesktop = useDesktop();
    return (
        <ContentBox p={isDesktop ? 8 : 5} withBorder {...props}>
            {image && <Stack mb={isDesktop ? 6 : 4} alignItems='center'><img src={fileUrl(image)} width={isDesktop ? 264 : 148} height='auto' alt='info_image' /></Stack>}
            {title && (
                <Typography component='h3' variant={isDesktop ? 'mediumHeader2' : 'mediumBody2'} lineHeight='1.5' color='grayscale.shade95'>
                    {title}
                </Typography>
            )}
            {text && (
                <Typography component='p' variant={isDesktop ? 'regularBody2' : 'regularCaption3'} lineHeight={isDesktop ? '1.5' : '1.4'} color='grayscale.shade90' mt={isDesktop ? 3 : 2}>
                    {text}
                </Typography>
            )}
        </ContentBox>
    );
};
